// requires: npm i query-string, public/ccTranResult.html

<template>
  <div>
    <span v-show="showProcResults">
      proc results: {{ resultCode }}: {{ returnResultMsg }}
    </span>
    <iframe
      v-if="showIFrame"
      className="iframe-window"
      @load="iFrameLoad"
      :src="mpiHostedPageUrl"
    ></iframe>
  </div>
</template>

<script>
import { callProc, apiParam, apiPType } from "../services/APointAPI";
import queryString from "query-string";

export default {
  name: "CCTran",
  emits: ["tranResult"],
  props: {
    org_id: {
      type: Number,
      default: 1,
    },
    tranType: {
      type: String,
      required: true,
      validator: function(value) {
        // The value must match one of these strings
        return ["token", "tran"].indexOf(value) !== -1;
      },
    },
    ccTerminalID: {
      type: Number,
      default: null,
    },
    ccTranID: {
      type: Number,
      default: null,
    },
    returnDomain: {
      type: String,
      /*
        window.location.protocol +
        "//" +
        window.location.host +
        "/" +
        "ccTranResult.html",*/
      default: "https://mtc.build-app.co.il/ccTranResult.html",
    },
    dbName: {
      type: String,
      required: false,
    },
    schemaName: {
      type: String,
      required: false,
    },
    userID: {
      type: Number,
    },
    contactID: {
      type: Number,
    },
  },
  data() {
    return {
      resultCode: 0, //pending
      returnResultMsg: undefined,
      mpiHostedPageUrl: undefined,
      ccReturnUrl: "",
      showIFrame: false,
    };
  },
  computed: {
    showProcResults() {
      return this.resultCode !== 0;
    },
  },
  mounted() {
    //TODO: remove dev init
    //TODO: set 10 minutes timer
    let procParams = [
      apiParam("org_id", this.org_id, apiPType.TinyInt),
      apiParam("tranType", this.tranType === "token" ? 1 : 2, apiPType.TinyInt),
      apiParam("ccTerminalID", this.ccTerminalID, apiPType.SmallInt),
      apiParam("ccTranID", this.ccTranID, apiPType.Int),
      apiParam("userID", this.userID, apiPType.SmallInt),
      apiParam(
        "returnDomain",
        window.location.href.includes("localhost:") ||  window.location.href.includes("wstest")
          ? window.location.protocol +
              "//" +
              window.location.host +
              "/" +
              "ccTranResult.html"
          : this.returnDomain,
        apiPType.NVarChar
      ),
      apiParam("contactID", this.contactID, apiPType.Int),
    ];
    // console.log("ccMpiTran Params:", procParams);
    callProc("ccMpiTran", procParams, undefined, this.dbName, this.schemaName)
      .then((result) => {
        // console.log(`apiLoginProc: ${result}`)
        result = JSON.parse(result);
        if (result.Table.length > 0) {
          //  console.log("result.Table", result.Table);
          this.resultCode = result.Table[0].resultCode;
          this.returnResultMsg = result.Table[0].returnResultMsg;
          this.mpiHostedPageUrl = result.Table[0].mpiHostedPageUrl;
          const showIFrame = result.Table[0].resultCode == 0;
          if (showIFrame) {
            if (window.cordova.platformId === "browser") {
              this.showIFrame = true;
            } else {
              this.goCreditGard(this.mpiHostedPageUrl);
            }
          }
          // console.log("mpiHostedPageUrl: ", this.mpiHostedPageUrl);
        } else {
          this.resultCode = 0;
        }
      })
      .catch((error) => {
        console.log(error);
      });
    // document.querySelector("#Track2CardNo").value = "4580000000000000";
    // document.querySelector("#expMonth").value = "04";
    // document.querySelector("#expYear").value = "36";
    // document.querySelector("#personalId").value = "000000000";
    // document.querySelector("#cvv").value = "123";
  },
  methods: {
    goCreditGard(url) {
      window.inAppBrowserRef = window.cordova.InAppBrowser.open(
        url,
        "_blank",
        "zoom=no,loadstop=yes,exit=yes,hideurlbar=yes"
      );
      window.inAppBrowserRef.addEventListener("loadstop", (e) => {
        // disable zoom
        var meta =
          "var meta = document.createElement('meta');" +
          "meta.name = 'viewport';" +
          "meta.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no';" +
          "var head = document.getElementsByTagName('head')[0];" +
          "head.appendChild(meta);";

        window.inAppBrowserRef.executeScript({ code: meta });

        if (e.url.includes("ccTranResult")) {
          window.inAppBrowserRef.close();
          window.inAppBrowserRef = undefined;
          let E = {};
          E.target = {};
          E.target.contentWindow = {};
          E.target.contentWindow.location = new URL(e.url);
          this.iFrameLoad(E);
        }
      });
      window.inAppBrowserRef.addEventListener("exit", (e) => {
        console.log("inAppBrowserRef-exit", e);
        this.$emit("tranResult", "actionCanceled");
      });
      /* 

      var target = "_blank";

      var options = "location=no,zoom=no,toolbar=no,beforeload=yes";
      window.inAppBrowserRef = window.cordova.InAppBrowser.open(
        url,
        // "craditGard",
        target,
        options
      ); //.addEventListener('loadstart', (e)=>{console.log(e);});
      // this.inAppBrowserRef.addEventListener('message',  (e)=>{console.log(e);});
      window.inAppBrowserRef.addEventListener("loadstart", (e) => {
        console.log("inAppBrowserRef-loadstart", e);
      });

      window.inAppBrowserRef.addEventListener("loadstop", (e) => {
        console.log("inAppBrowserRef-loadstop", e);
      });

      window.inAppBrowserRef.addEventListener("loaderror", (e) => {
        console.log("inAppBrowserRef-loaderror", e);
      });

      window.inAppBrowserRef.addEventListener("beforeload", (e) => {
        console.log("inAppBrowserRef-beforeload", e);
        let E = {};
        E.target = {};
        E.target.contentWindow = {};
        E.target.contentWindow.location = new URL(e.url);
        this.iFrameLoad(E);
      });*/
    },
    iFrameLoad(e) {
      // console.log("iframe load", e);
      this.ccReturnUrl = e.target.contentWindow.location;
      // console.log("iframe loaded:", this.ccReturnUrl);
      if (this.ccReturnUrl.href.indexOf("ccTranResult.html") > 0) {
        const search = queryString.parse(this.ccReturnUrl.search);
        // console.log("this.ccReturnUrl: ", this.ccReturnUrl);
        // console.log("search: ", search);
        this.resultCode = search.mpiResult;
        // console.log("search.mpiResult", search.mpiResult);
        switch (search.mpiResult) {
          case "-2":
            //http://localhost:8080/ccTranResult.html?mpiResult=2&tokenID=121&ccTranID=0&txId=89b855e6-6027-4c99-8df6-3dd59d53396f&uniqueID=DevERP-TOKENID-121&lang=HE
            // console.log("action canceled");
            this.$emit("tranResult", "actionCanceled");
            break;

          case "0":
            // console.log("action success");

            if (this.tranType === "token") {
              //http://localhost:8080/ccTranResult.html?mpiResult=0&tokenID=123&ccTranID=0&uniqueID=DevERP-TOKENID-123&lang=HE&authNumber=&cgUid=53934520&responseMac=03e1f6387f770d39fd5104d5148a1fb54ec6383297ac2f9b3335af93b48d77d6&cardToken=1094060020700000&cardExp=1221&personalId=&cardMask=458000******0000&txId=283aeae6-07c4-41ee-8d97-621207952504&numberOfPayments=0&firstPayment=&periodicalPayment=
              let p = [
                apiParam("tokenID", search.tokenID),
                apiParam("cardToken", search.cardToken, 22),
                apiParam("cardExp", search.cardExp, 22),
                apiParam("personalId", search.personalId, 22),
                apiParam("authNumber", search.authNumber, 22),
                apiParam("paramURL", this.ccReturnUrl.search, 22),
              ];
              // console.log("ccUpdateToken: ", p);
              callProc(
                "ccUpdateToken",
                p,
                undefined,
                this.dbName,
                this.schemaName
              ).then(
                () =>
                  this.$emit(
                    "tranResult",
                    "OK",
                    search.tokenID,
                    search.cardMask?.substr(search.cardMask.length - 4)
                  ),
                (reject) => this.$emit("tranResult", "tokenUpdateError", reject)
              );
            } else {
              //ccTran action
              let p = [
                apiParam("ccTranID", +search.ccTranID),
                apiParam("tranResult", 0),
                apiParam("cardExp", search.cardExp, 22),
                apiParam("personalId", search.personalId, 22),
                apiParam("cardMask", search.cardMask, 22),
                apiParam("authNumber", search.authNumber, 22),
                apiParam("numberOfPayments", +search.numberOfPayments),
                apiParam("firstPayment", +search.firstPayment, 13),
                apiParam("periodicalPayment", +search.periodicalPayment, 13),
                apiParam("errorText", null, 22),
              ];
              // console.log("ccUpdateTranMpi: ", p);
              callProc(
                "ccUpdateTranMpi",
                p,
                undefined,
                this.dbName,
                this.schemaName
              ).then(
                () => this.$emit("tranResult", "OK", search.ccTranID),
                (reject) => this.$emit("tranResult", "tokenUpdateError", reject)
              );
            }
            break;
          case "-1":
            // console.log("action error");
            if (this.tranType === "token") {
              this.$emit("tranResult", search.errorText);
            } else {
              //ccTran action
              let p = [
                apiParam("ccTranID", +search.ccTranID),
                apiParam("tranResult", search.errorCode),
                apiParam("cardExp", search.cardExp, 22),
                apiParam("personalId", search.personalId, 22),
                apiParam("cardMask", search.cardMask, 22),
                apiParam("authNumber", search.authNumber, 22),
                apiParam("numberOfPayments", +search.numberOfPayments),
                apiParam("firstPayment", +search.firstPayment, 13),
                apiParam("periodicalPayment", +search.periodicalPayment, 13),
                apiParam("errorText", search.errorText, 22),
              ];
              // console.log("ccUpdateTranMpi: ", p);
              callProc(
                "ccUpdateTranMpi",
                p,
                undefined,
                this.dbName,
                this.schemaName
              ).then(
                () => this.$emit("tranResult", "Error", search.errorText),
                (reject) => this.$emit("tranResult", "tranUpdateError", reject)
              );
            }
            break;
        }
        //send result paramters to server
        this.showIFrame = false;
        if (window.cordova.platformId !== "browser") {
          window.inAppBrowserRef.close();
        }
      }
    },
  },
};
</script>

<style scoped>
.iframe-window {
  min-width: 350px;
  min-height: 600px;
  /* border-color: red; */
  width: 100%;
  border: 0;
}
</style>
